export const uploadImageToBucket = async ({
  file,
  name,
  getToken,
  configData,
  notify,
}) => {
  try {
    if (!file) {
      throw new Error("Missing file");
    }

    const token = getToken();
    const form = new FormData();
    form.append("file", file, file.name);
    if (name) {
      form.append("name", name);
    }

    const res = await fetch(`${configData.DEMO_URL}/UploadImageToBucket`, {
      method: "POST",
      headers: {
        "x-access-token": token,
      },
      body: form,
    });

    if (!res.ok) {
      let errorMessage = `Failed uploading image (${res.status})`;
      try {
        const body = await res.json();
        if (body?.message) errorMessage = body.message;
      } catch (_) {}
      throw new Error(errorMessage);
    }

    const response = await res.json();
    const uploadedUrl = response?.image_url || response?.video_url || response?.url;
    if (!uploadedUrl) {
      throw new Error("Upload succeeded but no media URL returned");
    }
    return uploadedUrl;
  } catch (error) {
    console.log(error);
    notify("Failed to upload media to bucket", "error");
    return false;
  }
};

